import { render, staticRenderFns } from "./ImportAnnotations.vue?vue&type=template&id=353ce679"
import script from "./ImportAnnotations.vue?vue&type=script&lang=ts"
export * from "./ImportAnnotations.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports